@if (enableFilter && !customFilterActive) {
  <div class="filter">
    <mat-form-field subscriptSizing="dynamic" [appearance]="appearance">
      <mat-label>
        <mat-icon>search</mat-icon>
        <span>{{ filterLabel | async }}</span>
      </mat-label>
      <input
        matInput
        [ngModel]="filterValue"
        (ngModelChange)="filterValueChange.emit($event)"
        [maxLength]="246"
        (keyup)="_filterChange()"
      />
      <button
        matSuffix
        matIconButton
        aria-label="Clear"
        (click)="clearFilter()"
        [hidden]="filterValue === ''"
      >
        <mat-icon>close</mat-icon>
      </button>
    </mat-form-field>
    @if (areMultipleSearchScopes) {
      <button
        mat-icon-button
        [matTooltip]="showScopeTooltip | async"
        [matMenuTriggerFor]="scopeMenu"
      >
        <mat-icon>filter_list</mat-icon>
      </button>
      <mat-menu #scopeMenu="matMenu">
        @for (sc of this.searchScopeConfigs; track sc) {
          <button
            mat-menu-item
            (click)="_selectScope(sc)"
            [class.mat-mdc-menu-item--selected]="_selectedSearchScope === sc"
          >
            <span>{{ sc.displayname }}</span>
            @if (_selectedSearchScope === sc) {
              <mat-icon class="mat-mdc-menu-item-icon-suffix">check</mat-icon>
            }
          </button>
        }
      </mat-menu>
    }
  </div>
}
@if (enableFilterbuilder) {
  <span class="filter-builder">
    <button mat-icon-button (click)="_onFilterbuilderClick()" [class.enabled]="customFilterActive">
      <mat-icon>settings</mat-icon>
    </button>
  </span>
}
